import React, { useState, Suspense, lazy, useEffect } from 'react';
import ClientNavBar from '../../components/navbar/partner/ClientNavBar';
import image4 from '../../images/Resort.png';
import TabNavigation from '../../components/PartnerAdmin/TabNavigation';
import {jwtDecode} from 'jwt-decode';
import { useParams, useNavigate } from 'react-router-dom';

const Dashboard = lazy(() => import('../../components/PartnerAdmin/Dashboard/DashboardEvent'));
const EventAbout = lazy(() => import('../../components/PartnerAdmin/about/EventAbout'));
const EventInfo = lazy(() => import('../../components/PartnerAdmin/EventInfo/EventInfo'));
const OrderHistory = lazy(() => import('../../components/PartnerAdmin/orderhistroy/OrderHistoryEvent'));
const SubEvents = lazy(() => import('../../components/PartnerAdmin/subevents/SubEvents'));
const OrganizationInfo = lazy(() => import('../../components/PartnerAdmin/EventOrganizationInfo/OrganizationInfo'));

const getClientIdFromToken = () => {
  const token = localStorage.getItem('business_token');
  if (token) {
    try {
      const decoded = jwtDecode(token);
      const userData = JSON.parse(decoded.sub);
      return userData;
    } catch (error) {
      console.error('Error decoding token:', error);
    }
  }
  return null;
};

const PartnerAdminEvent = () => {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const { clientid, event} = useParams(); // Include params
  const navigate = useNavigate();
  const userData = getClientIdFromToken();
  const [productDetails, setProductDetails] = useState([]); // State for product details

  useEffect(() => {
    if (!userData || userData.client_id !== clientid) {
      alert('Unauthorized access');
      navigate('/'); // Redirect to a safe page
    } else {
      const fetchEntityData = async () => {
        const entityType = event ; // Determine the active parameter
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}/getbyentity?entityid=${entityType}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            setProductDetails(data.responseContent?.productDetails || []); // Extract productDetails
          } else {
            console.error('Failed to fetch entity data:', response.status);
          }
        } catch (error) {
          console.error('Error fetching entity data:', error);
        }
      };

      fetchEntityData();
    }
  }, [userData, clientid, event]);

  return (
    <div className="flex h-screen bg-gray-100">
      <TabNavigation currentTab={currentTab} setCurrentTab={setCurrentTab} entityType={event ? 'event' : ''} />

      <div className="flex-1 flex flex-col overflow-y-auto ml-64">
        <ClientNavBar />
        <div className="relative">
          <img
            src={image4}
            alt="Entity view"
            className="w-full h-32 object-cover"
          />
        </div>
        <div className="flex-1 p-2">
          <div className="container mx-auto py-0">
            <Suspense fallback={<div>Loading...</div>}>
              {currentTab === 'dashboard' && <Dashboard />}
              {currentTab === 'orderHistory' && <OrderHistory />}
              {currentTab === 'eventInfo' && <EventInfo />}
              {currentTab === 'subevents' && <SubEvents />}
              {currentTab === 'orgInfo' && <OrganizationInfo />}
              {currentTab ==='about' && <EventAbout />}
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerAdminEvent;
